import { SDS_FONT_SIZE_BODY_SMALL, SDS_FONT_LINEHEIGHT_BODY_XSMALL, SDS_FONT_SIZE_BODY_MEDIUM, SDS_FONT_LINEHEIGHT_BODY_MEDIUM, SDS_FONT_SIZE_BODY_LARGE, SDS_FONT_LINEHEIGHT_BODY_LARGE, SDS_FONT_SIZE_HEADING_SMALL, SDS_FONT_LINEHEIGHT_HEADING_SMALL, SDS_FONT_SIZE_HEADING_MEDIUM, SDS_FONT_LINEHEIGHT_HEADING_MEDIUM, SDS_FONT_WEIGHT_REGULAR, SDS_FONT_FAMILY_PRIMARY } from '@s-group/design-system-tokens/web/tokens/font.es6.js';
import { SDS_SIZE_BORDER_RADIUS_NONE, SDS_SIZE_BORDER_RADIUS_XSMALL, SDS_SIZE_BORDER_RADIUS_XXXSMALL, SDS_SIZE_BORDER_RADIUS_XLARGE, SDS_SIZE_BORDER_RADIUS_XXXLARGE, SDS_SIZE_BORDER_RADIUS_XXXXLARGE, SDS_SIZE_BORDER_RADIUS_XXXXXLARGE, SDS_SIZE_BORDER_RADIUS_XXXXXXLARGE, SDS_SIZE_BORDER_SMALL, SDS_SIZE_BORDER_LARGE } from '@s-group/design-system-tokens/web/tokens/size.es6.js';
import { SDS_SPACE_XXSMALL, SDS_SPACE_SMALL, SDS_SPACE_MEDIUM, SDS_SPACE_XSMALL, SDS_SPACE_LARGE, SDS_SPACE_XLARGE, SDS_SPACE_XXLARGE } from '@s-group/design-system-tokens/web/tokens/space.es6.js';
import { css } from 'styled-components';
import { SDS_MISC_ALPHA_MEDIUM } from '@s-group/design-system-tokens/web/tokens/misc.es6.js';
import { bordered } from '../common/util.js';

const BORDER_SIZE_NONE = '0';
const SPACE_NONE = '0';
const borderRadius = ({ alternative, rounding, sizing }) => rounding === 'sharp'
    ? SDS_SIZE_BORDER_RADIUS_NONE
    : alternative
        ? [
            SDS_SIZE_BORDER_RADIUS_XSMALL,
            SDS_SIZE_BORDER_RADIUS_XSMALL,
            SDS_SIZE_BORDER_RADIUS_NONE,
            SDS_SIZE_BORDER_RADIUS_NONE,
        ].join(' ')
        : rounding === 'small'
            ? SDS_SIZE_BORDER_RADIUS_XXXSMALL
            : sizing &&
                {
                    // size: border-radius
                    xsmall: SDS_SIZE_BORDER_RADIUS_XLARGE,
                    small: SDS_SIZE_BORDER_RADIUS_XXXLARGE,
                    medium: SDS_SIZE_BORDER_RADIUS_XXXXLARGE,
                    large: SDS_SIZE_BORDER_RADIUS_XXXXXLARGE,
                    xlarge: SDS_SIZE_BORDER_RADIUS_XXXXXXLARGE,
                }[sizing];
const font = ({ sizing }) => sizing &&
    [
        {
            // size: [font-size, line-height]
            xsmall: [SDS_FONT_SIZE_BODY_SMALL, SDS_FONT_LINEHEIGHT_BODY_XSMALL],
            small: [SDS_FONT_SIZE_BODY_MEDIUM, SDS_FONT_LINEHEIGHT_BODY_MEDIUM],
            medium: [SDS_FONT_SIZE_BODY_LARGE, SDS_FONT_LINEHEIGHT_BODY_LARGE],
            large: [
                SDS_FONT_SIZE_HEADING_SMALL,
                SDS_FONT_LINEHEIGHT_HEADING_SMALL,
            ],
            xlarge: [
                SDS_FONT_SIZE_HEADING_MEDIUM,
                SDS_FONT_LINEHEIGHT_HEADING_MEDIUM,
            ],
        }[sizing],
    ]
        .map(([fontSize, lineHeight]) => `${SDS_FONT_WEIGHT_REGULAR} ${fontSize} / ${lineHeight} '${SDS_FONT_FAMILY_PRIMARY}'`)
        .join('');
const paddingPill = ({ sizing, readOnly }) => sizing &&
    (readOnly
        ? {
            xsmall: [
                SDS_SPACE_XXSMALL,
                SDS_SPACE_SMALL,
                SDS_SPACE_XXSMALL,
                SDS_SPACE_SMALL,
            ],
            small: [
                SDS_SPACE_XXSMALL,
                SDS_SPACE_MEDIUM,
                SDS_SPACE_XXSMALL,
                SDS_SPACE_SMALL,
            ],
            medium: [
                SDS_SPACE_XSMALL,
                SDS_SPACE_LARGE,
                SDS_SPACE_XSMALL,
                SDS_SPACE_SMALL,
            ],
            large: [
                SDS_SPACE_SMALL,
                SDS_SPACE_XLARGE,
                SDS_SPACE_SMALL,
                SDS_SPACE_SMALL,
            ],
            xlarge: [
                SDS_SPACE_MEDIUM,
                SDS_SPACE_XXLARGE,
                SDS_SPACE_MEDIUM,
                SDS_SPACE_SMALL,
            ],
        }[sizing].join(' ')
        : {
            xsmall: [SDS_SPACE_XXSMALL, SDS_SPACE_SMALL],
            small: [SDS_SPACE_XXSMALL, SDS_SPACE_MEDIUM],
            medium: [SDS_SPACE_XSMALL, SDS_SPACE_LARGE],
            large: [SDS_SPACE_SMALL, SDS_SPACE_XLARGE],
            xlarge: [SDS_SPACE_MEDIUM, SDS_SPACE_XXLARGE],
        }[sizing]
            .map(dimension => bordered(dimension))
            .join(' '));
const paddingDefault = ({ sizing, readOnly }) => sizing &&
    (readOnly
        ? {
            // size: [vertical, horizontal]
            xsmall: [
                SDS_SPACE_XXSMALL,
                SDS_SPACE_SMALL,
                SDS_SPACE_XXSMALL,
                SPACE_NONE,
            ],
            small: [
                SDS_SPACE_XXSMALL,
                SDS_SPACE_SMALL,
                SDS_SPACE_XXSMALL,
                SPACE_NONE,
            ],
            medium: [
                SDS_SPACE_XSMALL,
                SDS_SPACE_SMALL,
                SDS_SPACE_XSMALL,
                SPACE_NONE,
            ],
            large: [
                SDS_SPACE_SMALL,
                SDS_SPACE_SMALL,
                SDS_SPACE_SMALL,
                SPACE_NONE,
            ],
            xlarge: [
                SDS_SPACE_MEDIUM,
                SDS_SPACE_SMALL,
                SDS_SPACE_MEDIUM,
                SPACE_NONE,
            ],
        }[sizing].join(' ')
        : {
            // size: [vertical, horizontal]
            xsmall: [SDS_SPACE_XXSMALL, SDS_SPACE_SMALL],
            small: [SDS_SPACE_XXSMALL, SDS_SPACE_SMALL],
            medium: [SDS_SPACE_XSMALL, SDS_SPACE_SMALL],
            large: [SDS_SPACE_SMALL, SDS_SPACE_SMALL],
            xlarge: [SDS_SPACE_MEDIUM, SDS_SPACE_SMALL],
        }[sizing]
            .map(dimension => bordered(dimension))
            .join(' '));
const padding = ({ alternative, rounding, sizing, readOnly }) => rounding === 'pill' && !alternative
    ? paddingPill({ sizing, readOnly })
    : paddingDefault({ sizing, readOnly });
const border = ({ alternative, readOnly, error, theme, }) => readOnly || alternative
    ? BORDER_SIZE_NONE
    : error
        ? `${SDS_SIZE_BORDER_SMALL} solid ${theme.colors.SDS_BRAND_COLOR_BORDER_ERROR}`
        : `${SDS_SIZE_BORDER_SMALL} solid ${theme.colors.SDS_BRAND_COLOR_BORDER_DEFAULT_GREY}`;
const alternativeBorder = ({ alternative, error, readOnly, theme, }) => alternative && !readOnly && !error
    ? `${SDS_SIZE_BORDER_SMALL} solid ${theme.colors.SDS_BRAND_COLOR_BORDER_DEFAULT_GREY}`
    : alternative && !readOnly && error
        ? `${SDS_SIZE_BORDER_SMALL} solid ${theme.colors.SDS_BRAND_COLOR_BORDER_ERROR}`
        : undefined; // Return undefined so the value won't break regular borders
const backgroundColor = ({ alternative, readOnly, theme, }) => readOnly
    ? theme.SDS_BRAND_COLOR_BACKGROUND_DEFAULT_GREY
    : alternative
        ? theme.colors.SDS_BRAND_COLOR_BACKGROUND_WEAK_GREY
        : theme.colors.SDS_BRAND_COLOR_BACKGROUND_DEFAULT_GREY;
const outline = ({ alternative, readOnly, theme, }) => alternative || readOnly
    ? 'none'
    : `${theme.colors.SDS_BRAND_COLOR_BORDER_STRONG_PRIMARY}
    solid ${SDS_SIZE_BORDER_LARGE}`;
const boxShadow = ({ alternative, readOnly, theme, }) => alternative &&
    !readOnly &&
    `0px ${SDS_SIZE_BORDER_LARGE} 0px 0px ${theme.colors.SDS_BRAND_COLOR_BORDER_STRONG_PRIMARY}`;
const textColor = ({ theme }) => theme.colors.SDS_BRAND_COLOR_TEXT_DEFAULT_GREY;
const TextAreaStyle = css `
    background-color: ${backgroundColor};
    border: ${border};
    border-bottom: ${alternativeBorder};
    border-radius: ${borderRadius};
    color: ${textColor};
    font: ${font};
    padding: ${padding};

    &::placeholder {
        color: ${({ theme }) => theme.colors.SDS_BRAND_COLOR_TEXT_STRONG_GREY};
    }

    &:focus {
        border-color: ${({ error, theme }) => error ? theme.colors.SDS_BRAND_COLOR_BORDER_ERROR : 'transparent'};
        box-shadow: ${boxShadow};
        outline: ${outline};
    }

    &[aria-disabled='true'],
    &[disabled] {
        opacity: ${SDS_MISC_ALPHA_MEDIUM};
        pointer-events: none;
    }

    &:invalid {
        border-color: ${({ theme }) => theme.colors.SDS_BRAND_COLOR_BORDER_ERROR};
    }
`;

export { TextAreaStyle };
//# sourceMappingURL=TextArea.styles.js.map
